import React, { FC } from 'react'
import OwnersContainer from 'containers/NewClient/Owners'

const NewOwnerPage: FC = () => <OwnersContainer />

export default NewOwnerPage
